import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools } from '../../../services'

import Switch from 'react-switch'
import { Label } from 'reactstrap'
import { Headerbar, FormInput, Loader, Select, OnOff, EditContainer, ImagesPicker, ConfirmLink } from '../../Reusable'

import { ChromePicker } from 'react-color'
import FadeIn from 'react-fade-in';

import { CopyToClipboard } from 'react-copy-to-clipboard'

const { useHistory } = require('react-router-dom')

const opts = [
  { value: 'out', label: "Sorties" },
  { value: 'digital', label: 'Bons plans' },
]

interface Props {
  match: any;
}
const CategoryScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const history = useHistory()

  const onFetch = async (id: string) => {
    try {
      const ref = Fire.store().collection('categories').doc(id)
      const element = await Fire.doc(ref)
      element.pictures = Tools.formatPictures(element.pictures)
      element.icons = Tools.formatPictures(element.icons)
      return element
    } catch (err) {
      setError("Impossible de charger la catégorie")
      console.warn(err)
    }
    return null
  }

  const onSave = async (item: any) => {
    const data = {
      ...item,
    }
    data.pictures = await Tools.uploadPictures('categories/' + item.id, item.pictures)
    data.icons = await Tools.uploadPictures('categories/icons/' + item.id, item.icons)

    try {
      if (item.id) {
        await Fire.store().collection('categories').doc(item.id).update(data)
      }
      else {
        const newItem = Fire.store().collection('categories').doc()
        data.createdAt = new Date()
        await newItem.set(data)
      }
      history.goBack()
    } catch (err) {
      setError("Impossible de modifier la catégorie")
      console.warn(err)
    }
  }

  const onRemove = async (item: any) => {
    try {
      await Fire.store().collection('categories').doc(item.id).delete()
      history.push('/app/categories')
    } catch (err) {
      setError("Impossible de supprimer la catégorie")
      console.warn(err)
    }
  }

  const renderContent = ({item, onChange, save, saving, remove, changed, setChanged}) => {
    return (
      <div>

        <ImagesPicker
          id='cat-pics'
          pictures={item.pictures}
          onChange={(pics: any) => onChange('pictures', pics)}
          />

        <ImagesPicker
          id='cat-icons'
          title="Choix d'une icone"
          pictures={item.icons}
          onChange={(pics: any) => onChange('icons', pics)}
          />

        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Informations</h3>
          </div>
          <div className="card-body">

            <div className="code-add-form">

              <OnOff
                label="Afficher"
                checked={item.active || false}
                onChange={(checked: boolean) => onChange('active', checked)}
                />

              <FormInput
                type="text"
                placeholder="Nom de la catégorie"
                disabled={saving}
                value={item.name}
                onChange={(evt: any) => onChange('name', evt.target.value)}
              />

              <div className="input-wrapper">
                <Label>Choisir un type de catégorie:</Label>
                <Select
                  value={item.type}
                  onChange={(val) => onChange('type', val)}
                  options={opts}
                />
              </div>

              <div className="input-wrapper" style={{marginTop: 12}}>
                <Label>Choisir une couleur:</Label>
                <ChromePicker
                  color={item.color || '#fff'}
                  onChangeComplete={(color) => onChange('color', color.hex)}
                  disabled={saving}
                />
              </div>
            </div>

            <div className="centered">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={save}
                disabled={saving || !changed}
                >
                { saving ? 'Chargement...' : 'Enregistrer' }
              </button>
            </div>
          </div>
        </div>

        { item.id !== undefined &&
          <div className="centered">
             <ConfirmLink
              title='Supprimer'
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir supprimer cette catégorie ?'
              onPress={remove}
              />
          </div>
        }
      </div>
    )
  }

  return (
    <EditContainer
      id={props.match.params.id}
      error={error}

      onFetch={onFetch}
      onSave={onSave}
      onRemove={onRemove}
      renderContent={renderContent}
      />
  );
}

export default withRouter(CategoryScreen)
